import * as React from 'react';
import Svg, {
  Circle,
  Defs,
  Ellipse,
  G,
  Image,
  LinearGradient,
  Path,
  Polygon,
  Rect,
  Stop,
} from 'react-native-svg';
import Styles from '../../Styles';
type EmptyCartSvgProps = {
  width: number | string;
  height: number | string;
};
export default class EmptyCartSvg extends React.Component<EmptyCartSvgProps> {
  render() {
    return (
      <Svg width={this.props.width} height={this.props.height}>
        <Defs>
          <LinearGradient
            x1="50.003653%"
            y1="100.017289%"
            x2="50.003653%"
            y2="0.00485949042%"
            id="LinearGradient-1"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="45734%"
            y1="29483%"
            x2="45734%"
            y2="14549%"
            id="LinearGradient-2"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="77188%"
            y1="59991%"
            x2="77188%"
            y2="32265%"
            id="LinearGradient-3"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="68394%"
            y1="82736%"
            x2="68394%"
            y2="75836%"
            id="LinearGradient-4"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="43287%"
            y1="50119%"
            x2="43287%"
            y2="37779%"
            id="LinearGradient-5"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="42807%"
            y1="60348%"
            x2="42807%"
            y2="49395%"
            id="LinearGradient-6"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="44205%"
            y1="39965%"
            x2="44205%"
            y2="26262%"
            id="LinearGradient-7"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <Polygon
            id="path-8"
            points="0.9448 0.956 76.7338 0.956 76.7338 8.4551 0.9448 8.4551"
          />
          <LinearGradient
            x1="50.003653%"
            y1="100.017289%"
            x2="50.003653%"
            y2="0.00485949042%"
            id="LinearGradient-10"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="45734%"
            y1="29483%"
            x2="45734%"
            y2="14549%"
            id="LinearGradient-11"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="59152%"
            y1="65418%"
            x2="59152%"
            y2="7222%"
            id="LinearGradient-12"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="77188%"
            y1="59991%"
            x2="77188%"
            y2="32265%"
            id="LinearGradient-13"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="68394%"
            y1="82736%"
            x2="68394%"
            y2="75836%"
            id="LinearGradient-14"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="43287%"
            y1="50119%"
            x2="43287%"
            y2="37779%"
            id="LinearGradient-15"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="42807%"
            y1="60348%"
            x2="42807%"
            y2="49395%"
            id="LinearGradient-16"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="35252%"
            y1="38093%"
            x2="35252%"
            y2="20104%"
            id="LinearGradient-17"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
          <LinearGradient
            x1="44205%"
            y1="39965%"
            x2="44205%"
            y2="26262%"
            id="LinearGradient-18"
          >
            <Stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
            <Stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
            <Stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
          </LinearGradient>
        </Defs>
        <G
          id="empty-cart-redesign"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <G id="Group-12" transform="translate(-124.000000, 5.000000)">
            <G
              id="Group-9"
              transform="translate(237.772591, 114.000000) rotate(18.000000) translate(-237.772591, -114.000000) translate(170.272591, 17.000000)"
            >
              <G
                id="undraw_confirmed_81ex-copy-2"
                transform="translate(67.500000, 106.000000) scale(-1, 1) translate(-67.500000, -106.000000) translate(0.000000, 18.000000)"
                fillRule="nonzero"
              >
                <Path
                  d="M134.999999,108.471069 C135.002865,96.8770121 126.071522,87.1853262 114.383864,86.0998416 C102.696205,85.0143571 92.0920337,92.8916932 89.9063539,104.283023 L20,102.410297 L20.7674322,114.271818 C20.7674322,114.271818 10.7992158,136.987959 63.1890691,143.040432 L63.1890691,166 L123.754596,166 L123.754596,127.826261 C130.714108,123.801509 134.99338,116.436176 134.999999,108.471069 Z"
                  id="Shape"
                  fill="url(#LinearGradient-1)"
                />
                <Path
                  d="M23.742221,114.376731 C23.742221,114.376731 14.2328636,136.160665 64.2155862,141.972299 L64.2155862,164 L122,164 L122,105.66482 L23,103 L23.742221,114.376731 Z"
                  id="Shape"
                  fill="#D9A48C"
                />
                <Path
                  d="M53.3874808,36.1267772 L53.3874808,36.1267772 C50.2657099,40.9973776 43.7516651,42.4609351 38.8075893,39.4025467 L7.92876781,19.2838851 C3.00265227,16.1972952 1.52241314,9.75666073 4.61566105,4.8683025 L4.61566105,4.8683025 C7.73697645,0.00438844423 14.2426845,-1.45841049 19.184444,1.59253297 L50.0632655,21.7111946 C54.9932985,24.7941734 56.4786761,31.2355686 53.3874808,36.1267772 Z"
                  id="Shape"
                  fill="url(#LinearGradient-2)"
                />
                <Circle
                  id="Oval"
                  fill="#AE806B"
                  cx="111.5"
                  cy="108.5"
                  r="21.5"
                />
                <Path
                  d="M124.583772,112.707344 L124.583772,112.707344 C118.347102,114.157039 114.066818,110.06901 112.624399,103.803661 L98.2941517,50.323241 C96.8683131,44.0335816 100.762947,37.7670151 107.012225,36.2956354 L107.012225,36.2956354 C113.27032,34.8626051 119.505437,38.7768829 120.969432,45.0576817 L132.663533,99.9183669 C134.105953,106.186493 130.817678,111.257649 124.583772,112.707344 Z"
                  id="Shape"
                  fill="url(#LinearGradient-3)"
                />
                <Rect
                  id="Rectangle-Path"
                  fill="url(#LinearGradient-4)"
                  x="50"
                  y="157"
                  width="83"
                  height="19"
                />
                <Rect
                  id="Rectangle-Path"
                  fill="#4C73DF"
                  x="54.520147"
                  y="157.715921"
                  width="78"
                  height="15"
                />
                <Path
                  d="M40.387683,82.1680989 L40.387683,82.1680989 C37.2727306,86.9971377 30.7716498,88.4484939 25.8374534,85.4164151 L4.91956991,72.1228394 C0.00291427636,69.0633968 -1.474775,62.678168 1.61231704,57.8319011 L1.61231704,57.8319011 C4.72726943,53.0028623 11.2283502,51.5515061 16.1625466,54.5835849 L37.0804301,67.8771606 C41.9970857,70.9366032 43.474775,77.321832 40.387683,82.1680989 L40.387683,82.1680989 Z"
                  id="Shape"
                  fill="url(#LinearGradient-5)"
                />
                <Path
                  d="M36.3852969,105.151646 L36.3852969,105.151646 C33.2636595,109.996865 26.7473864,111.453371 21.801692,108.411349 L8.9316745,99.1855681 C4.00318919,96.1166709 2.52165214,89.7104905 5.61595232,84.8483537 L5.61595232,84.8483537 C8.73758973,80.0031353 15.2538628,78.5466289 20.1995573,81.5886508 L33.0695747,90.8171711 C37.9963626,93.8859571 39.4777069,100.29008 36.3852969,105.151646 L36.3852969,105.151646 Z"
                  id="Shape"
                  fill="url(#LinearGradient-6)"
                />
                <Path
                  d="M45.4037523,58.115453 C42.3185064,62.9974022 35.8821172,64.4642792 30.9966266,61.3988904 L4.86971476,44.335554 C0.00258989715,41.240911 -1.45983281,34.7849179 1.59624771,29.884547 C4.68149362,25.0025978 11.1178828,23.5357208 16.0033734,26.6011096 L42.1302852,43.664446 C46.9974101,46.759089 48.4598328,53.2150821 45.4037523,58.115453 Z"
                  id="Shape"
                  fill="url(#LinearGradient-7)"
                />
              </G>
              <G id="Group-18" transform="translate(26.000000, 0.000000)">
                <Polygon
                  id="Fill-1"
                  fill="#EA202A"
                  points="0 135.935 81.679 135.935 81.679 16.896 0 16.896"
                />
                <G id="Group-17" transform="translate(0.000000, 0.044000)">
                  <Path
                    d="M65.7178,77.1202 C65.6738,77.4772 65.5758,77.9272 65.4258,78.4652 C65.2748,79.0022 65.0768,79.5212 64.8318,80.0272 C64.5868,80.5312 64.2958,80.9632 63.9618,81.3212 C63.6268,81.6802 63.2538,81.8582 62.8408,81.8582 C62.5848,81.8582 62.3728,81.7942 62.2068,81.6622 C62.0388,81.5292 61.9048,81.3572 61.8048,81.1452 C61.7038,80.9332 61.6338,80.6912 61.5958,80.4212 C61.5568,80.1522 61.5378,79.8742 61.5378,79.5862 C61.5378,79.1022 61.6008,78.5832 61.7288,78.0312 C61.8568,77.4782 62.0768,76.8402 62.3878,76.1102 C62.6998,75.3832 63.0178,74.7692 63.3408,74.2712 C63.6638,73.7762 64.0158,73.3342 64.4008,72.9482 C64.7838,72.5622 65.1928,72.2582 65.6278,72.0312 C66.0608,71.8052 66.5068,71.6912 66.9628,71.6912 L65.7178,77.1202 Z M53.6068,67.8232 C53.9068,66.3152 54.0548,65.5592 54.0548,65.5592 C54.0548,65.5592 54.3008,64.7472 54.7928,63.1212 C55.2838,61.4952 55.7058,60.3212 56.0578,59.5992 C56.4108,58.8792 56.7658,58.3052 57.1178,57.8832 C57.4708,57.4612 57.8008,57.2482 58.1068,57.2482 C58.1928,57.2482 58.2398,57.3632 58.2568,57.5932 C58.2728,57.8232 58.2808,58.1012 58.2808,58.4282 C58.1808,59.4482 57.9458,60.5512 57.5788,61.7362 C57.2098,62.9212 56.7738,64.1062 56.2718,65.2992 C55.7688,66.4872 55.2358,67.6432 54.6718,68.7662 C54.1078,69.8882 53.5748,70.8992 53.0718,71.7962 C53.1288,70.6572 53.3078,69.3322 53.6068,67.8232 L53.6068,67.8232 Z M42.7278,77.6772 C42.5668,78.5072 42.3528,79.2122 42.0858,79.7972 C41.8178,80.3822 41.5068,80.8652 41.1508,81.2502 C40.7928,81.6342 40.4258,81.8252 40.0478,81.8252 C39.6138,81.8252 39.2418,81.7342 38.9298,81.5502 C38.6188,81.3662 38.3668,81.1212 38.1788,80.8162 C37.9888,80.5102 37.8498,80.1502 37.7608,79.7372 C37.6708,79.3282 37.6268,78.8882 37.6268,78.4202 C37.6268,77.4962 37.7168,76.6682 37.8938,75.9332 C38.0718,75.1982 38.3178,74.5272 38.6298,73.9202 C38.9408,73.3132 39.3008,72.8162 39.7148,72.4252 C40.1258,72.0362 40.5608,71.8432 41.0158,71.8432 C41.3608,71.8432 41.6568,71.9362 41.9018,72.1252 C42.1458,72.3132 42.3458,72.5702 42.5038,72.8932 C42.6578,73.2162 42.7758,73.5972 42.8528,74.0372 C42.9318,74.4772 42.9698,74.9532 42.9698,75.4652 C42.9698,76.1102 42.8888,76.8492 42.7278,77.6772 L42.7278,77.6772 Z M75.0598,77.2212 C74.5018,77.9712 73.9528,78.6432 73.4068,79.2392 C73.1718,79.4932 72.9258,79.7372 72.6648,79.9752 C72.4018,80.2122 72.1408,80.4262 71.8788,80.6122 C71.6178,80.8012 71.3588,80.9532 71.1038,81.0682 C70.8478,81.1832 70.6028,81.2412 70.3678,81.2412 C70.0568,81.2412 69.8528,81.0992 69.7598,80.8092 C69.6648,80.5212 69.6168,80.1242 69.6168,79.6142 C69.6168,79.0172 69.7078,78.2852 69.8918,77.4122 C70.0758,76.5412 70.2398,75.7642 70.3828,75.0842 C70.5278,74.4042 70.6528,73.7392 70.7668,73.0912 C70.8778,72.4422 70.9328,71.8522 70.9328,71.3192 C70.9328,70.9722 70.9028,70.6962 70.8408,70.4942 C70.7798,70.2922 70.6938,70.1332 70.5818,70.0202 C70.4708,69.9092 70.3418,69.8362 70.1958,69.8012 C70.0488,69.7672 69.8938,69.7502 69.7258,69.7502 C69.6028,69.7502 69.4758,69.7542 69.3478,69.7612 C69.2178,69.7662 69.0928,69.7672 68.9688,69.7672 C68.8248,69.7672 68.6818,69.7612 68.5418,69.7432 C68.4018,69.7252 68.2648,69.6872 68.1298,69.6332 C67.9958,69.5772 67.8838,69.4872 67.7948,69.3622 C67.7048,69.2392 67.6128,69.1132 67.5158,68.9832 C67.4218,68.8532 67.3008,68.7382 67.1558,68.6372 C67.0098,68.5362 66.8078,68.4862 66.5518,68.4862 C65.7778,68.4862 65.0188,68.6492 64.2758,68.9772 C63.5298,69.3042 62.8218,69.7452 62.1488,70.3002 C61.4788,70.8532 60.8588,71.5032 60.2938,72.2452 C59.7278,72.9882 59.1988,73.8702 58.7068,74.8912 C58.2148,75.9122 57.8508,76.8602 57.6148,77.7362 C57.4248,78.4452 57.3318,79.1352 57.2948,79.8152 C57.1228,79.9222 56.9548,80.0332 56.7748,80.1392 C56.4448,80.3362 56.1228,80.5102 55.8098,80.6622 C55.4948,80.8122 55.1988,80.9332 54.9208,81.0232 C54.6408,81.1132 54.3918,81.1582 54.1758,81.1582 C54.0878,81.1582 53.9928,81.0932 53.8908,80.9652 C53.7918,80.8362 53.6968,80.6622 53.6068,80.4422 C53.5178,80.2242 53.4428,79.9752 53.3808,79.7012 C53.3188,79.4282 53.2888,79.1432 53.2888,78.8522 L53.2888,78.6172 C53.3218,78.3912 53.3678,78.1612 53.4228,77.9252 C53.4788,77.6882 53.5358,77.4682 53.5908,77.2612 C53.6458,77.0542 53.7048,76.8582 53.7668,76.6802 C53.8278,76.5002 53.8868,76.3532 53.9418,76.2412 C54.4548,75.2312 55.0158,74.1962 55.6248,73.1412 C56.2328,72.0822 56.8368,71.0092 57.4378,69.9162 C58.0398,68.8252 58.6188,67.7242 59.1748,66.6172 C59.7298,65.5092 60.2178,64.4032 60.6408,63.3012 C61.0628,62.1972 61.3998,61.1012 61.6478,60.0112 C61.8968,58.9202 62.0218,57.8462 62.0218,56.7952 C62.0218,56.3712 61.9818,55.9552 61.9048,55.5462 C61.8268,55.1382 61.6908,54.7712 61.4998,54.4482 C61.3078,54.1262 61.0438,53.8672 60.7088,53.6712 C60.3728,53.4732 59.9478,53.3762 59.4318,53.3762 C58.7238,53.3762 58.0258,53.5772 57.3418,53.9842 C56.6548,54.3912 55.9968,54.9482 55.3668,55.6592 C54.7378,56.3692 54.1368,57.2012 53.5628,58.1582 C52.9898,59.1132 52.4588,60.1412 51.9698,61.2432 C51.4808,62.3432 50.9938,63.8042 50.5058,65.6252 C50.0208,67.4472 49.7768,68.3572 49.7768,68.3572 C49.7768,68.3572 49.6158,69.2692 49.2968,71.0932 C49.2428,71.3962 49.1998,71.6782 49.1558,71.9622 C48.6098,71.3852 48.0438,70.8622 47.4368,70.4482 C46.6288,69.8952 45.7638,69.4572 44.8408,69.1292 C43.9158,68.8012 42.9258,68.6362 41.8688,68.6362 C40.6318,68.6362 39.5198,68.8622 38.5278,69.3122 C37.5378,69.7632 36.7008,70.3802 36.0158,71.1652 C35.3318,71.9512 34.8048,72.8752 34.4378,73.9372 C34.0838,74.9662 33.9078,76.1932 33.8968,77.6022 C33.1298,78.0992 32.3668,78.6102 31.6258,79.1502 C30.7618,79.7782 29.8998,80.4032 29.0358,81.0262 C28.1748,81.6482 27.2808,82.2082 26.3568,82.7042 C25.4328,83.2002 24.4628,83.5992 23.4428,83.9042 C22.4248,84.2112 21.3248,84.3642 20.1458,84.3642 C19.1998,84.3642 18.3488,84.2202 17.5918,83.9312 C16.8348,83.6432 16.1928,83.2042 15.6718,82.6162 C15.1478,82.0292 14.7438,81.2942 14.4608,80.4122 C14.1768,79.5302 14.0348,78.4952 14.0348,77.3072 C14.0348,76.5002 14.1158,75.6152 14.2768,74.6552 C14.4378,73.6962 14.6698,72.7052 14.9698,71.6832 C15.2708,70.6622 15.6348,69.6382 16.0638,68.6112 C16.4928,67.5842 16.9738,66.5962 17.5068,65.6462 C18.0428,64.6982 18.6228,63.8072 19.2538,62.9772 C19.8818,62.1472 20.5468,61.4282 21.2478,60.8212 C21.9478,60.2172 22.6808,59.7372 23.4428,59.3832 C24.2058,59.0282 24.9888,58.8502 25.7888,58.8502 C26.4678,58.8502 27.0448,58.9552 27.5178,59.1612 C27.9908,59.3672 28.3768,59.6382 28.6758,59.9782 C28.9778,60.3192 29.1968,60.7122 29.3288,61.1622 C29.4638,61.6132 29.5298,62.0912 29.5298,62.5922 C29.5298,63.5372 29.3428,64.4032 28.9698,65.1872 C28.5968,65.9742 28.1188,66.6482 27.5328,67.2172 C26.9498,67.7852 26.2938,68.2242 25.5648,68.5362 C24.8348,68.8472 24.1138,69.0022 23.4018,69.0022 C23.1348,69.0022 22.9148,68.9832 22.7418,68.9452 C22.5708,68.9052 22.4218,68.8642 22.2998,68.8182 C22.1758,68.7742 22.0648,68.7332 21.9658,68.6932 C21.8668,68.6552 21.7488,68.6362 21.6148,68.6362 C21.3918,68.6362 21.2178,68.6922 21.0898,68.8042 C20.9618,68.9132 20.8638,69.0592 20.7968,69.2372 C20.7308,69.4152 20.6858,69.6122 20.6638,69.8292 C20.6408,70.0462 20.6308,70.2552 20.6308,70.4552 C20.6308,70.5892 20.6338,70.7172 20.6388,70.8402 C20.6448,70.9622 20.6468,71.0682 20.6468,71.1572 C20.6468,71.6692 20.8978,72.0612 21.3988,72.3342 C21.8998,72.6072 22.6548,72.7442 23.6698,72.7442 C24.4368,72.7442 25.2058,72.5992 25.9718,72.3092 C26.7408,72.0202 27.4818,71.6282 28.1928,71.1312 C28.9068,70.6372 29.5708,70.0502 30.1898,69.3702 C30.8058,68.6922 31.3438,67.9662 31.7998,67.1912 C32.2558,66.4182 32.6158,65.6122 32.8768,64.7712 C33.1388,63.9302 33.2678,63.0972 33.2678,62.2742 C33.2678,61.0502 33.0608,59.9872 32.6428,59.0862 C32.2268,58.1832 31.6888,57.4382 31.0318,56.8492 C30.3748,56.2592 29.6358,55.8202 28.8108,55.5372 C27.9878,55.2542 27.1748,55.1122 26.3738,55.1122 C25.1388,55.1122 23.9468,55.3132 22.8008,55.7172 C21.6548,56.1212 20.5638,56.6782 19.5278,57.3892 C18.4928,58.1012 17.5188,58.9362 16.6068,59.8942 C15.6928,60.8532 14.8568,61.8912 14.0938,63.0142 C13.3318,64.1352 12.6498,65.3072 12.0488,66.5272 C11.4478,67.7472 10.9388,68.9742 10.5208,70.2012 C10.1028,71.4292 9.7828,72.6332 9.5608,73.8152 C9.3378,74.9962 9.2268,76.1032 9.2268,77.1362 C9.2268,78.6172 9.4578,80.0312 9.9188,81.3762 C10.3818,82.7222 11.0408,83.9022 11.8988,84.9182 C12.7548,85.9352 13.7878,86.7412 14.9948,87.3402 C16.2028,87.9382 17.5588,88.2372 19.0598,88.2372 C20.4198,88.2372 21.6568,88.1452 22.7758,87.9652 C23.8938,87.7792 24.9178,87.5342 25.8468,87.2252 C26.7778,86.9162 27.6258,86.5552 28.3938,86.1452 C29.1628,85.7342 29.8718,85.3012 30.5228,84.8512 C31.1748,84.3992 31.7798,83.9122 32.3428,83.3872 C32.9048,82.8622 33.4478,82.3632 33.9708,81.8912 C34.1598,81.7202 34.3448,81.5802 34.5328,81.4192 C34.7098,81.8762 34.9158,82.3122 35.1728,82.7122 C35.6178,83.4002 36.1888,83.9612 36.8848,84.3902 C37.5788,84.8182 38.4168,85.0312 39.3968,85.0312 C40.0748,85.0312 40.7158,84.9152 41.3168,84.6812 C41.9178,84.4482 42.4708,84.1292 42.9788,83.7292 C43.4848,83.3292 43.9358,82.8542 44.3318,82.3092 C44.7258,81.7662 45.0588,81.1802 45.3328,80.5582 C45.6048,79.9332 45.8138,79.2882 45.9588,78.6202 C46.1028,77.9512 46.1758,77.2912 46.1758,76.6342 C46.1758,75.7322 46.0948,74.9232 45.9338,74.2042 C45.7728,73.4862 45.5308,72.8052 45.2078,72.1592 L45.3408,71.9742 C45.7418,72.2412 46.2198,72.5732 46.7768,72.9702 C47.3338,73.3632 47.8988,73.8462 48.4718,74.4132 C48.6008,74.5402 48.7128,74.6412 48.8378,74.7622 C48.8248,75.0082 48.8138,75.2502 48.8138,75.4672 C48.8138,76.7382 48.9218,77.9512 49.1378,79.1082 C49.3548,80.2632 49.6548,81.2792 50.0368,82.1562 C50.4198,83.0322 50.8688,83.7292 51.3848,84.2522 C51.8998,84.7712 52.4568,85.0312 53.0558,85.0312 C53.4458,85.0312 53.8648,84.9812 54.3108,84.8822 C54.7578,84.7792 55.2168,84.6452 55.6868,84.4752 C56.1558,84.3072 56.6228,84.1142 57.0878,83.8952 C57.4728,83.7172 57.8408,83.5332 58.2058,83.3492 C58.3178,83.5032 58.4218,83.6602 58.5478,83.7942 C58.9368,84.2022 59.3848,84.5172 59.8928,84.7362 C60.3978,84.9552 60.9188,85.0652 61.4538,85.0652 C61.9578,85.0652 62.4628,84.9832 62.9688,84.8162 C63.4738,84.6522 63.9588,84.4402 64.4248,84.1812 C64.8888,83.9222 65.3188,83.6332 65.7118,83.3132 C66.1058,82.9952 66.4358,82.6802 66.7048,82.3712 C67.0638,83.2662 67.4908,83.9452 67.9848,84.4132 C68.4778,84.8822 69.0948,85.1152 69.8338,85.1152 C70.4458,85.1152 71.0568,84.9632 71.6698,84.6602 C72.2818,84.3542 72.8568,83.9842 73.3908,83.5452 C73.9258,83.1072 74.4068,82.6452 74.8348,82.1612 C75.2638,81.6772 75.6058,81.2542 75.8608,80.8942 L75.0598,77.2212 Z"
                    id="Fill-2"
                    fill="#FFFCD6"
                  />
                  <Polygon
                    id="Fill-4"
                    fill="#869F97"
                    points="6.2925 149 75.3875 149 81.6785 135.891 0.0005 135.891"
                  />
                  <Polygon
                    id="Fill-6"
                    fill="#BDE7E2"
                    points="6.2925 3.7432 75.3875 3.7432 81.6785 16.8512 0.0005 16.8512"
                  />
                  <G id="Group-10" transform="translate(2.000000, 0.000000)">
                    <G id="Clip-9" />
                    <Path
                      d="M3.3008,8.4551 L74.3788,8.4551 C75.6788,8.4551 76.7338,7.3991 76.7338,6.1001 L76.7338,3.3121 C76.7338,2.0101 75.6788,0.9551 74.3788,0.9551 L3.3008,0.9551 C1.9998,0.9551 0.9448,2.0101 0.9448,3.3121 L0.9448,6.1001 C0.9448,7.3991 1.9998,8.4551 3.3008,8.4551"
                      id="Fill-8"
                      fill="#A6BDB1"
                      mask="url(#Mask-9)"
                    />
                  </G>
                  <Path
                    d="M18.1611,120.9688 L18.1611,120.9688 C21.6311,120.9688 24.4451,118.1548 24.4451,114.6838 L24.4451,52.7908 C24.4451,49.3208 21.6311,46.5078 18.1611,46.5078 C14.6911,46.5078 11.8781,49.3208 11.8781,52.7908 L11.8781,114.6838 C11.8781,118.1548 14.6911,120.9688 18.1611,120.9688 M11.8781,28.4448 L11.8781,28.4448 C11.8781,24.9738 14.6911,22.1588 18.1611,22.1588 C21.6311,22.1588 24.4451,24.9738 24.4451,28.4448 C24.4451,31.9128 21.6311,34.7258 18.1611,34.7258 C14.6911,34.7258 11.8781,31.9128 11.8781,28.4448"
                    id="Fill-11"
                    fillOpacity="0.5"
                    fill="#FFFFBB"
                  />
                  <Polygon
                    id="Fill-13"
                    fillOpacity="0.3"
                    fill="#810045"
                    points="55.763 135.891 81.679 135.891 81.679 16.861 55.763 16.861"
                  />
                  <Path
                    d="M38.4824,7.0621 L19.6314,7.0621 C18.3304,7.0621 17.2754,6.0081 17.2754,4.7061 C17.2754,3.4031 18.3304,2.3501 19.6314,2.3501 L38.4824,2.3501 C39.7844,2.3501 40.8374,3.4031 40.8374,4.7061 C40.8374,6.0081 39.7844,7.0621 38.4824,7.0621"
                    id="Fill-15"
                    fill="#C9FFFF"
                  />
                </G>
              </G>
              <Path
                d="M127.474751,52.4855648 L127.474751,52.4855648 C124.534073,56.9974699 118.397993,58.3533296 113.740647,55.5203228 L84.6429222,36.8684649 C80.0026021,34.0091665 78.6081528,28.0428949 81.5217908,23.5144352 L81.5217908,23.5144352 C84.4624688,19.0025301 90.5985486,17.6466704 95.2558945,20.4796772 L124.347991,39.1205892 C128.997158,41.9785282 130.394992,47.9534063 127.474751,52.4855648 Z"
                id="Shape"
                fill="#D9A48C"
                fillRule="nonzero"
                transform="translate(104.500000, 38.000000) scale(-1, 1) translate(-104.500000, -38.000000) "
              />
              <Path
                d="M127.487262,123.47421 L127.487262,123.47421 C124.547939,127.997464 118.414686,129.356734 113.759485,126.516601 L101.640783,117.91341 C97.0026009,115.046919 95.608794,109.065641 98.5210898,104.52579 L98.5210898,104.52579 C101.460413,100.002536 107.593667,98.6432664 112.248867,101.483399 L124.364756,110.103051 C128.99366,112.967963 130.387602,118.937083 127.487262,123.47421 L127.487262,123.47421 Z"
                id="Shape"
                fill="#D9A48C"
                fillRule="nonzero"
                transform="translate(113.000000, 114.000000) scale(-1, 1) translate(-113.000000, -114.000000) "
              />
              <Path
                d="M130.502945,99.4531355 L130.502945,99.4531355 C127.610067,103.997452 121.573727,105.363051 116.992084,102.509694 L97.5674532,89.9968227 C93.0025598,87.1169846 91.6307768,81.1078544 94.4970547,76.5468645 L94.4970547,76.5468645 C97.389933,72.0025483 103.426273,70.6369488 108.007916,73.4903064 L127.432547,86.0031773 C131.99744,88.8830154 133.369223,94.8921456 130.502945,99.4531355 Z"
                id="Shape"
                fill="#D9A48C"
                fillRule="nonzero"
                transform="translate(112.500000, 88.000000) scale(-1, 1) translate(-112.500000, -88.000000) "
              />
              <Path
                d="M130.506432,75.5007959 L130.506432,75.5007959 C127.61878,79.9974784 121.593345,81.3487636 117.019979,78.525315 L92.5592019,62.8081791 C88.0025552,59.9585276 86.6332504,54.0123854 89.4943502,49.4992041 L89.4943502,49.4992041 C92.3820023,45.0025216 98.4074375,43.6512364 102.980803,46.474685 L127.438817,62.1918209 C131.996438,65.040576 133.367021,70.9869069 130.506432,75.5007959 Z"
                id="Shape"
                fill="#D9A48C"
                fillRule="nonzero"
                transform="translate(110.000000, 62.500000) scale(-1, 1) translate(-110.000000, -62.500000) "
              />
              <Path
                d="M19.3834357,55.2324293 L19.3834357,55.2324293 C24.8412797,55.2418752 29.2634026,59.6639434 29.272916,65.1217874 L29.3745104,123.40698 C29.3839811,128.840378 24.9870191,133.252695 19.5536209,133.262166 C19.5422293,133.262186 19.5308376,133.262186 19.519446,133.262166 L19.519446,133.262166 C14.0616019,133.25272 9.63947905,128.830652 9.62996572,123.372808 L9.5283713,65.0876155 C9.51890058,59.6542173 13.9158626,55.2419003 19.3492608,55.2324295 C19.3606524,55.2324097 19.3720441,55.2324096 19.3834357,55.2324293 Z"
                id="Rectangle-Path"
                fill="#D9A48C"
                fillRule="nonzero"
                transform="translate(19.451441, 94.247298) scale(-1, 1) rotate(-13.010000) translate(-19.451441, -94.247298) "
              />
              <G
                id="Group-17"
                transform="translate(54.000000, 112.000000)"
                fill="#324A5E"
              >
                <Polygon id="Fill-1" points="0 18 2 18 2 0 0 0" />
                <Polygon id="Fill-2" points="3 18 4 18 4 0 3 0" />
                <Polygon id="Fill-3" points="5 15 6 15 6 0 5 0" />
                <Polygon id="Fill-4" points="6 15 7 15 7 0 6 0" />
                <Polygon id="Fill-5" points="13 15 14 15 14 0 13 0" />
                <Polygon
                  id="Fill-6"
                  points="11.7816901 15 12.2183099 15 12.2183099 0 11.7816901 0"
                />
                <Polygon id="Fill-7" points="10 15 11 15 11 0 10 0" />
                <Polygon id="Fill-8" points="8 15 9 15 9 0 8 0" />
                <Polygon id="Fill-9" points="15 15 17 15 17 0 15 0" />
                <Polygon id="Fill-10" points="18 15 19 15 19 0 18 0" />
                <Polygon id="Fill-11" points="20 15 22 15 22 0 20 0" />
                <Polygon id="Fill-12" points="22 15 23 15 23 0 22 0" />
                <Polygon id="Fill-13" points="30 18 31 18 31 0 30 0" />
                <Polygon id="Fill-14" points="28 18 29 18 29 0 28 0" />
                <Polygon id="Fill-15" points="26 15 27 15 27 0 26 0" />
                <Polygon id="Fill-16" points="24 15 25 15 25 0 24 0" />
              </G>
            </G>
            <G
              id="Group-11"
              transform="translate(360.964932, 245.289331) rotate(-6.000000) translate(-360.964932, -245.289331) translate(263.964932, 95.289331)"
            >
              <G id="undraw_confirmed_81ex-copy" fillRule="nonzero">
                <Path
                  d="M192.913982,202.484127 C192.918056,185.851943 180.224003,171.948794 163.612418,170.391619 C147.000834,168.834443 131.929201,180.134828 128.82271,196.47619 L29.4653145,193.789683 L30.5560604,210.805556 C30.5560604,210.805556 16.3883065,243.392857 90.8496263,252.075397 L90.8496263,285.011905 L176.930973,285.011905 L176.930973,230.25 C186.822475,224.476316 192.904574,213.910423 192.913982,202.484127 Z"
                  id="Shape"
                  fill="url(#LinearGradient-10)"
                />
                <Path
                  d="M33.9676269,211.519841 C33.9676269,211.519841 20.4009774,242.72619 91.7094844,251.051587 L91.7094844,282.607143 L174.148376,282.607143 L174.148376,199.039683 L32.9087276,195.222222 L33.9676269,211.519841 Z"
                  id="Shape"
                  fill="#D9A48C"
                />
                <Path
                  d="M75.1691591,81.2936508 L75.1691591,81.2936508 C70.6943032,88.33262 61.3568428,90.4477465 54.2698312,86.0277778 L10.007045,56.952381 C2.94577813,52.4916555 0.823951414,43.1836803 5.25792151,36.1190476 L5.25792151,36.1190476 C9.73212452,29.0897415 19.0576347,26.9757112 26.1413262,31.3849206 L70.4041124,60.4603175 C77.4709946,64.9158241 79.6001871,74.2248987 75.1691591,81.2936508 Z"
                  id="Shape"
                  fill="url(#LinearGradient-11)"
                />
                <Path
                  d="M72.7169713,79.7063492 L72.7169713,79.7063492 C68.5574823,86.2491982 59.8782058,88.215371 53.2905484,84.1071429 L12.1328052,57.0595238 C5.56923016,52.9131694 3.59682901,44.2612998 7.71807097,37.6944444 L7.71807097,37.6944444 C11.87756,31.1515955 20.5568364,29.1854226 27.1444939,33.2936508 L68.2942754,60.3253968 C74.8703653,64.46978 76.8475533,73.1341301 72.7169713,79.7063492 Z"
                  id="Shape"
                  fill="#D9A48C"
                />
                <Ellipse
                  id="Oval"
                  fill="#AE806B"
                  cx="158.499756"
                  cy="203.547619"
                  rx="30.9588711"
                  ry="30.8611111"
                />
                <Rect
                  id="Rectangle-Path"
                  fill="url(#LinearGradient-12)"
                  x="29.453372"
                  y="0"
                  width="128.349739"
                  height="230.936508"
                  rx="4.86111111"
                />
                <Rect
                  id="Rectangle-Path"
                  fill="#FFFFFF"
                  x="31.1850306"
                  y="3.12301587"
                  width="124.878461"
                  height="224.698413"
                  rx="5.41269841"
                />
                <Path
                  d="M124.997138,8.75793651 C124.250681,13.6817652 120.0127,17.3266817 115.017211,17.3412698 L71.8889599,17.3412698 C66.8949813,17.3247276 62.6592398,13.6802831 61.913014,8.75793651 L39.0630821,8.75793651 C37.8049582,8.75688348 36.5980022,9.25435507 35.7080007,10.1408019 C34.8179992,11.0272487 34.317939,12.2299755 34.3179394,13.484127 L34.3179394,217.452381 C34.3168831,218.706532 34.8159305,219.909677 35.7051854,220.796868 C36.5944402,221.684059 37.8009769,222.18254 39.0591013,222.18254 L148.189421,222.18254 C149.447544,222.183593 150.6545,221.686121 151.544502,220.799674 C152.434503,219.913228 152.934564,218.710501 152.934563,217.456349 L152.934563,13.4880952 C152.93562,12.2339442 152.436572,11.0307994 151.547317,10.1436083 C150.658062,9.25641725 149.451526,8.75793607 148.193401,8.75793651 L124.997138,8.75793651 Z"
                  id="Shape"
                  fill={Styles.primaryColor}
                />
                <Path
                  d="M80.6800868,11.4444444 L106.922728,11.4444444 C107.36105,11.4444444 107.716379,11.799774 107.716379,12.2380952 L107.716379,12.3849206 C107.716379,12.8232419 107.36105,13.1785714 106.922728,13.1785714 L80.6800868,13.1785714 C80.2417656,13.1785714 79.886436,12.8232419 79.886436,12.3849206 L79.886436,12.2380952 C79.886436,11.799774 80.2417656,11.4444444 80.6800868,11.4444444 Z"
                  id="Rectangle-Path"
                  fill="#DBDBDB"
                />
                <Ellipse
                  id="Oval"
                  fill="#DBDBDB"
                  cx="113.627903"
                  cy="12.1388889"
                  rx="1.04297599"
                  ry="1.03968254"
                />
                <Path
                  d="M178.51136,208.992063 L178.51136,208.992063 C169.526639,211.063492 163.360342,205.222222 161.282352,196.269841 L140.637797,119.853175 C138.583694,110.866057 144.194412,101.911937 153.197298,99.8095238 L153.197298,99.8095238 C162.212884,97.7619071 171.195369,103.354909 173.304442,112.329365 L190.15129,190.718254 C192.229281,199.674603 187.4921,206.920635 178.51136,208.992063 Z"
                  id="Shape"
                  fill="url(#LinearGradient-13)"
                />
                <Rect
                  id="Rectangle-Path"
                  fill="#D9A48C"
                  transform="translate(166.753348, 158.312390) rotate(-13.010000) translate(-166.753348, -158.312390) "
                  x="152.66521"
                  y="102.238977"
                  width="28.1762749"
                  height="112.146825"
                  rx="14.0436508"
                />
                <Rect
                  id="Rectangle-Path"
                  fill="url(#LinearGradient-14)"
                  x="71.4948582"
                  y="272.281746"
                  width="117.832401"
                  height="27.3809524"
                />
                <Rect
                  id="Rectangle-Path"
                  fill="#4C73DF"
                  x="76.6685615"
                  y="275.665406"
                  width="111.463082"
                  height="21.4285714"
                />
                <Path
                  d="M57.9879211,163.269841 L57.9879211,163.269841 C53.5674269,170.225138 44.3416067,172.315536 37.3393851,167.948413 L7.65437778,148.801587 C0.67704861,144.395052 -1.41997124,135.198364 2.96098584,128.218254 L2.96098584,128.218254 C7.38148012,121.262957 16.6073003,119.172559 23.6095219,123.539683 L53.2945292,142.686508 C60.2718584,147.093043 62.3688782,156.289731 57.9879211,163.269841 L57.9879211,163.269841 Z"
                  id="Shape"
                  fill="url(#LinearGradient-15)"
                />
                <Path
                  d="M50.5358179,203.797619 L50.5358179,203.797619 C46.0759263,210.816724 36.7661099,212.926716 29.7001832,208.519841 L11.3127554,195.154762 C4.27141545,190.708953 2.15473956,181.428535 6.57557437,174.384921 L6.57557437,174.384921 C11.035466,167.365815 20.3452824,165.255823 27.4112091,169.662698 L45.7986369,183.031746 C52.8375517,187.477393 54.9539522,196.754831 50.5358179,203.797619 L50.5358179,203.797619 Z"
                  id="Shape"
                  fill="url(#LinearGradient-16)"
                />
                <G
                  id="Group"
                  opacity="0.5"
                  transform="translate(57.589839, 79.761905)"
                  fill="url(#LinearGradient-17)"
                >
                  <Ellipse
                    id="Oval"
                    cx="36.0344222"
                    cy="35.7103175"
                    rx="35.8035344"
                    ry="35.6904762"
                  />
                </G>
                <Path
                  d="M49.0509704,202.801587 L49.0509704,202.801587 C44.8914814,209.344436 36.212205,211.310609 29.6245475,207.202381 L12.4751561,194.757937 C5.91158106,190.611582 3.93917991,181.959712 8.06042186,175.392857 L8.06042186,175.392857 C12.2199109,168.850008 20.8991873,166.883835 27.4868448,170.992063 L44.6322554,183.460317 C51.1827007,187.604389 53.1552928,196.238672 49.0509704,202.801587 L49.0509704,202.801587 Z"
                  id="Shape"
                  fill="#D9A48C"
                />
                <Path
                  d="M56.3557832,162.218254 L56.3557832,162.218254 C52.1962941,168.761103 43.5170177,170.727276 36.9293602,166.619048 L8.99989642,148.603175 C2.43632138,144.45682 0.463920233,135.804951 4.58516219,129.238095 L4.58516219,129.238095 C8.7446512,122.695246 17.4239277,120.729073 24.0115851,124.837302 L51.9410489,142.853175 C58.504624,146.999529 60.4770251,155.651399 56.3557832,162.218254 Z"
                  id="Shape"
                  fill="#D9A48C"
                />
                <Path
                  d="M65.6629505,122.93254 L65.6629505,122.93254 C61.2206644,129.918332 51.9532402,132.01735 44.9188747,127.630952 L7.30008441,103.214286 C0.29216282,98.7860271 -1.81350407,89.5478671 2.58678835,82.5357143 L2.58678835,82.5357143 C7.02907452,75.5499219 16.2964987,73.4509041 23.3308642,77.8373016 L60.9496545,102.253968 C67.9575761,106.682227 70.063243,115.920387 65.6629505,122.93254 Z"
                  id="Shape"
                  fill="url(#LinearGradient-18)"
                />
                <Path
                  d="M63.6645767,121.662698 L63.6645767,121.662698 C59.5050877,128.205547 50.8258112,130.17172 44.2381538,126.063492 L9.00387724,103.194444 C2.44030221,99.04809 0.467901057,90.3962204 4.58914301,83.8293651 L4.58914301,83.8293651 C8.74863202,77.2865161 17.4279085,75.3203433 24.0155659,79.4285714 L59.2458616,102.297619 C65.8108403,106.442669 67.7850826,115.094813 63.6645767,121.662698 Z"
                  id="Shape"
                  fill="#D9A48C"
                />
              </G>
              <Image
                id="Screen-Shot-2019-04-18-at-9.53.52-AM"
                x="41.6064675"
                y="25.0788832"
                width="104"
                height="58.9113924"
                href={require('./camera.png')}
              />
            </G>
            <Rect
              id="Rectangle"
              fill="#1D1E1F"
              transform="translate(418.903484, 462.157450) rotate(-6.000000) translate(-418.903484, -462.157450) "
              x="370.403484"
              y="387.15745"
              width="97"
              height="150"
            />
            <Rect
              id="Rectangle-Copy-2"
              fill="#1D1E1F"
              transform="translate(156.336019, 281.333523) rotate(18.000000) translate(-156.336019, -281.333523) "
              x="121.336019"
              y="190.333523"
              width="70"
              height="182"
            />
            <Rect
              id="Rectangle-Copy-3"
              fill="#1D1E1F"
              transform="translate(81.000000, 359.643858) rotate(-52.000000) translate(-81.000000, -359.643858) "
              x="46"
              y="284.643858"
              width="70"
              height="150"
            />
          </G>
        </G>
      </Svg>
    );
  }
}
